var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { useChuckClientContext } from './useChuckClientContext';
import { useAPI } from './useAPI';
import { CacheKeys, Storage } from '../constants';
export const useFlagEvaluation = () => {
    const { post } = useAPI();
    const queryClient = useQueryClient();
    const { client } = useChuckClientContext();
    return useMutation((key) => __awaiter(void 0, void 0, void 0, function* () {
        const user = yield client.Storage.getItem(Storage.AB_ID);
        const res = yield post({
            url: '/flags/evaluate',
            data: {
                key,
                user
            }
        });
        return res.data;
    }), {
        onSuccess: (data) => {
            queryClient.setQueryData(CacheKeys.FLAGS, (flags) => (Object.assign(Object.assign({}, (flags ? flags : {})), data)));
        }
    });
};
export const useUserQuery = () => {
    const { client } = useChuckClientContext();
    const { get } = useAPI();
    return useQuery(CacheKeys.FLAGS, () => __awaiter(void 0, void 0, void 0, function* () {
        const user = yield client.Storage.getItem(Storage.AB_ID);
        const res = yield get({ url: `/ab-users/${user}` });
        return res.data;
    }), { enabled: false });
};
export const useABUserCreation = () => {
    const queryClient = useQueryClient();
    const { post } = useAPI();
    const { client } = useChuckClientContext();
    return useMutation(() => {
        return post({ url: '/ab-users', data: {} }).then((res) => res.data);
    }, {
        onSuccess: (data) => __awaiter(void 0, void 0, void 0, function* () {
            yield client.Storage.setItem(Storage.AB_ID, data.id);
            queryClient.setQueryData(CacheKeys.FLAGS, data.flags);
        })
    });
};
export const useUserAlias = () => {
    const queryClient = useQueryClient();
    const { client } = useChuckClientContext();
    const { post } = useAPI();
    return useMutation((alias) => __awaiter(void 0, void 0, void 0, function* () {
        const user = yield client.Storage.getItem(Storage.AB_ID);
        const res = yield post({
            url: `/ab-users/${user}/alias`,
            data: {
                alias
            }
        });
        return res.data;
    }), {
        onSuccess: (data) => __awaiter(void 0, void 0, void 0, function* () {
            yield client.Storage.setItem(Storage.AB_ID, data.id);
            queryClient.setQueryData(CacheKeys.FLAGS, data.flags);
        })
    });
};
//# sourceMappingURL=useFlags.js.map